import { OrganizationsFilter } from "@/types/utils";

type StringKeys = "oid" | "bid";
type ObjectKeys = "organizations_filter";

function getItem(key: StringKeys): string | undefined;
function getItem(key: ObjectKeys): OrganizationsFilter | undefined;

function getItem<D>(key: StringKeys | ObjectKeys): D | undefined {
    const value = localStorage.getItem(key);

    if (!value) return undefined;
    return JSON.parse(value);
}

function setItem(key: StringKeys, value: string): void;
function setItem(key: ObjectKeys, value: OrganizationsFilter): void;

function setItem<D>(key: StringKeys | ObjectKeys, value: D) {
    localStorage.setItem(key, JSON.stringify(value));
}

function removeItem(key: StringKeys | ObjectKeys) {
    localStorage.removeItem(key);
}

function clear() { 
    localStorage.clear();
}

export default {
    getItem,
    setItem,
    removeItem,
    clear,
};
